import React, { useContext } from 'react';
import { AdHocIDGButton } from '@mummssoftware/common-ui';
import { PNGlobalContext } from './PNGlobalContext';
import { SET_PATIENT_ON_AD_HOC_IDG_AGENDA } from './constants';
export const ConnectedAdHocIDGButton = ({
  pim,
  observation,
  patient,
  currentUser,
  agency
}) => {
  const {
    patientOnAdHocIDGAgenda,
    dispatchPN
  } = useContext(PNGlobalContext);
  const hide = Boolean(dispatchPN && patientOnAdHocIDGAgenda !== false);

  const onAddedToAdHocAgenda = () => {
    if (dispatchPN) {
      dispatchPN({
        type: SET_PATIENT_ON_AD_HOC_IDG_AGENDA,
        payload: true
      });
    }
  };

  return /*#__PURE__*/React.createElement(AdHocIDGButton, {
    pim: pim,
    observation: observation,
    patient: patient,
    currentUser: currentUser,
    agency: agency,
    hide: hide,
    onAddedToAdHocAgenda: onAddedToAdHocAgenda
  });
};